import { AnomaliesFactory } from "../anomalies/factories/anomalies-factory"
import { ChartType } from "../models/charts/chart-type.enum"
const WEB_FLOW_ANOMALY_ELEMENT_SELECTOR = '[data-anomalies]'

const initAnomalies = (anomaliesElements: Array<HTMLElement>): void => {
    const factory = new AnomaliesFactory()
    anomaliesElements
      .map(e => { return { e, charType: e.dataset.anomalies as ChartType } })
      .map(desc => factory.instantiate(desc.e, desc.charType))
      .forEach((a) => a.Init())
  }
  
  const getAnomaliesElements = (container: Element | Document = document) => Array.from(container.querySelectorAll<HTMLElement>(WEB_FLOW_ANOMALY_ELEMENT_SELECTOR))
  const initAnomalyFeed = (elements = getAnomaliesElements()) => initAnomalies(elements)
  
  document.addEventListener('authChange', _ => {
    initAnomalyFeed()
  })